import { RoleTemplateClient } from '@frontend/role/api';
import { CustomRoleTemplate } from '@frontend/role/types';
import { useEffect, useMemo, useState } from 'react';

import { CustomRoleTemplateSelectProps } from './custom-role-template-select.component';
import { buildPermissionMapFromTemplate, compareArrays, togglePermissionRight } from './custom-role-template-select.utils';

interface ViewProps {
    options: { [key: string]: string[] } | null;
    onChange: (key: string, right: string, value: boolean) => void;
}

const useCustomRoleTemplateSelect = (props: CustomRoleTemplateSelectProps): ViewProps => {
    const [template, changeTemplate] = useState<CustomRoleTemplate | null>(null);
    const options = useMemo(() => {
        if (props.entity_type === undefined || template === null) return null;
        return template[props.entity_type];
    }, [template, props.entity_type]);

    useEffect(() => {
        RoleTemplateClient.fetchCustomRoleTemplates().then(changeTemplate);
    }, []);

    useEffect(() => {
        if (!options) return;
        const needsInit = props.value === undefined || compareArrays(Object.keys(options), Object.keys(props.value)).nonOverlapping.length !== 0;
        if (!needsInit) return;
        props.onChange(buildPermissionMapFromTemplate(options, props.value));
    }, [options]);

    const onChange = (key: string, right: string, newValue: boolean) => {
        if (!props.value) return;
        props.onChange(togglePermissionRight(props.value, key, right, newValue));
    };

    return { options, onChange };
};

export default useCustomRoleTemplateSelect;
